import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=ffd0ed5c&scoped=true&"
import script from "./Rules.vue?vue&type=script&lang=ts&"
export * from "./Rules.vue?vue&type=script&lang=ts&"
import style0 from "./Rules.vue?vue&type=style&index=0&id=ffd0ed5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd0ed5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
